import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../header/Header.jsx';
import '../../App.css';

function ErrorPage() {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="error-page" style={{ 
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 60px)',
        textAlign: 'center'
      }}>
        <h1>404 Page Not Found</h1>
        <button className='error-btn'
          onClick={() => navigate('/')}
          style={{
            marginTop: '20px',
            padding: '10px 20px',
            background: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Back to Home
        </button>
      </div>
    </>
  );
}

export default ErrorPage;
